import { render, staticRenderFns } from "./TableTypeCustomFieldContact.vue?vue&type=template&id=7a23718a"
import script from "./TableTypeCustomFieldContact.vue?vue&type=script&lang=js"
export * from "./TableTypeCustomFieldContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports